module.exports = __webpack_public_path__ + "static/media/nerd-face-svgrepo-com.f74cd698.svg";